<template>
  <div name="modulePreview" :style="{ height: contentHeight }">
    <module-preview :data="moduleData" style="height: 100%"></module-preview>
  </div>
</template>

<script>
  import { getSysModule } from '@/api/sysModule.js'
  import ModulePreview from './modulePreview.vue'
  export default {
    components: {
      ModulePreview,
    },
    props: {
      id: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        moduleData: {},
      }
    },
    computed: {
      contentHeight() {
        return document.documentElement.clientHeight + 'px'
      },
    },
    created() {
      getSysModule(this.id).then((result) => {
        if (result.state) {
          this.moduleData = result.value
        }
      })
    },
  }
</script>

<style lang="scss" scoped></style>
